import React, { Fragment, useState } from "react";
import ActionRequest from "./Components/ActionRequest";
import ActionStatusC from "./Components/ActionStatus";
import RepositoryC from "./Components/Repository";
import styles from "./devicebackup.module.scss";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";

const { TabPane } = Tabs;
const Upgrade = () => {
  const { level } = useAppSelector((state) => state.global);
  // const [IsUpdate, setIsUpdate] = useState <boolean>(false);
  const [currentTab, setCurrentTab] = useState(level === "set" ? "2" : "1");
  const AuthLevel = ["super", "super_super", "admin"];
  const { t } = useTranslation();
  // Upgrade 的 子頁面切換 Tabs標籤頁  Upgrade(裝置升級) 與 Repository(資料庫)

  return (
    <Tabs
      type="card"
      defaultActiveKey={level === "set" ? "2" : "1"}
      onChange={(tab) => {
        setCurrentTab(tab);
      }}
    >
      {AuthLevel.includes(level) && (
        <TabPane tab={t("ISMS.Upgrade")} key="1">
          {currentTab === "1" && (
            <Fragment>
              <ActionRequest />
              <ActionStatusC />
            </Fragment>
          )}
        </TabPane>
      )}
      <TabPane tab={t("ISMS.Repository")} key="2">
        {currentTab === "2" && (
          <Fragment>
            <RepositoryC />
          </Fragment>
        )}
      </TabPane>
    </Tabs>
  );
};

export default Upgrade;
